import React, { useEffect, useState } from 'react';
import "./style.sass";
import { BarraStepper } from 'components/Credito/BarraStepper';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export function SolicitudFinalizadaDesktop({ numFolio, nombreTarjeta }) {

    const history = useHistory();
    const [folio, setFolio] = useState("123456789");
    const [nombre, setNombre] = useState("tu nombre aquí");

    const [, setcopied] = useState(false);
    const [click, setclick] = useState(false);

    const onCopy = () => { setcopied(true); }

    const handleClickCopy = () => {
        setclick(!click);
    }

    useEffect(() => {
        if (numFolio) {
            setFolio(numFolio.folio);
        }
    }, [numFolio])

    useEffect(() => {
        if (nombreTarjeta) {
            setNombre(nombreTarjeta)
        }
    }, [nombreTarjeta])

    const finalizar = () => {
        history.replace(`${BASE_PATH}${SUB_DIRECTORY}home`);
    };

    return (
        <>
            <BarraStepper itemActivo={4} />

            <div className="infoEmpleoFrom finalizar">

                <div className="infoFinGeneral">
                    {/* <div className="bxLfin">
                        <div className="cardDesk">
                            <div className="imaTarjetaDesk">
                                <div className="imgDesk" >
                                    <div className="numeroTarjeta">
                                        <span>{numeroCard}</span>
                                    </div>
                                    <div className="titular">
                                        <span>{nombre}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="bxRfin">
                        <img src="img/paloma_aprobado.svg"></img>
                        <h2 className="tituloFin">¡Tu solicitud ha sido enviada con éxito!</h2>
                        <p className="copyNormal">Te enviaremos un correo con el estatus de tu solicitud</p>

                        <div className='capturaP marginBottom20'>
                            <img src="/credito-claroshop/img/icon_captura_pantalla.svg"></img>
                            <span className='fontgris'>Captura esta pantalla o anota tu número de folio</span>
                        </div>

                        <p className="folio">Folio de solicitud </p>

                        <div className="divFolio">
                            <CopyToClipboard text={folio} onCopy={() => setcopied(true)}>
                                <>
                                    <span className="boldFolio">#{folio}</span>
                                </>
                            </CopyToClipboard>

                            <CopyToClipboard text={folio} onCopy={() => onCopy()}>
                                <button onClick={handleClickCopy} className="botonCopy" />
                            </CopyToClipboard>
                        </div>
                    </div>
                </div>

                <div className="bxFinalizar">
                    <button className="btnRedCard" onClick={finalizar}>Finalizar</button>
                </div>
            </div>
        </>
    )
}